import { money } from "../format"

export function BookingTotal({ totalPence, className, label = "Total amount due" }: { totalPence: number; className: string; label?: string }) {
    return <div className={className}>
        <span className="ah-total-copy">
            <span className="ah-total-label">{label}</span>
            <span className="ah-total-note">No hidden fees at checkout</span>
        </span>
        <strong>{money(totalPence)}</strong>
    </div>
}
